import React, { Component } from "react";
import { withTranslation } from "react-i18next";

import RightBlueArrow from "../rightbluearrow";
import LeftBlueArrow from "../leftbluearrow";

class LeftRightBlueArrow extends Component {
  render() {
    const { t } = this.props;
    return (
      <a className="showPointer">
        {window.lang === "ar" ? (
          <RightBlueArrow></RightBlueArrow>
        ) : (
          <LeftBlueArrow></LeftBlueArrow>
        )}
      </a>
    );
  }
}

export default withTranslation()(LeftRightBlueArrow);
